import moment from "moment";

export const formatTime = (time: string | null): string => {
    if (!time) {
        return "-"
    }

    return moment.parseZone(time).format("YYYY-MM-DD HH:mm:ss");
}